// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DisabledActionsController = function ($scope, $http) {    
    
    $http.get('/api/v1/prometheusActions/disabled-actions')
        .then(function(response) {
            $scope.disabledActions = response.data;
        });
};

DisabledActionsController.$inject = ['$scope', '$http'];
